export default "__VITE_ASSET__BvY9Ehmx__"